export default __webpack_public_path__ + "static/media/Mills-Berry-logo.0195ec7e.png";